import { useState, useEffect } from "react"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"
import exportFileType from "shared/lib/fileTypeExtractor"

// origin: string ( 초기 값 )
const usePostVideoUpload = (origin) => {
    const [imgState, setImgState] = useState(null)
    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    useEffect(() => {
        origin && setImgState(origin)
    }, [origin])

    const setImg = (e) => {
        const file = e.target.files[0]

        if (!file) setAlert("동영상이 선택되지 않았습니다.")
        else if (!["avi", "mp4", "wmv"].includes(exportFileType(file.name).toLowerCase())) setAlert("avi, mp4, wmv 동영상만 업로드 가능합니다.")
        else if (Math.round(file.size) > 50 * 1024 * 1024) setAlert("50mb 이하 동영상만 업로드 가능합니다.")
        else {
            const formdata = new FormData()
            formdata.append("src", file)
            fetchRequest("POST", "/admin/util/upload/video", null, formdata)
        }
    }

    const deleteImg = () => {
        setImgState(null)
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                setImgState(fetchResult?.data?.path)
                break
            case 400:
                if (fetchResult?.data?.error_code === "src") setAlert("동영상의 확장자와 용량을 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
        }
    }, [fetchResult])

    return [imgState, setImg, deleteImg]
}

export default usePostVideoUpload